var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsUser = function SvgIconsUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M32 28c5.378 0 9.764 4.245 9.99 9.566L42 38v4c0 1.105-.895 2-2 2-1.026 0-1.871-.772-1.987-1.767L38 42v-4c0-3.195-2.498-5.807-5.647-5.99L32 32H16c-3.195 0-5.807 2.498-5.99 5.647L10 38v4c0 1.105-.895 2-2 2-1.026 0-1.871-.772-1.987-1.767L6 42v-4c0-5.378 4.245-9.764 9.566-9.99L16 28h16zM24 4c5.523 0 10 4.477 10 10s-4.477 10-10 10-10-4.477-10-10S18.477 4 24 4zm0 4c-3.314 0-6 2.686-6 6s2.686 6 6 6 6-2.686 6-6-2.686-6-6-6z"
  })));
};
export default SvgIconsUser;